module.exports = __webpack_public_path__ + "static/media/orquestra_salao_7.cacb8de0.jpg";